import { UserRole } from '../types';

/**
 * Whether a role can submit session/message ratings (thumbs up/down).
 * super_admin is the highest-privilege role and must be included alongside
 * admin/trainer, not treated as a separate case that falls through.
 */
export const canRate = (userRole: UserRole | null): boolean =>
  userRole === 'admin' || userRole === 'trainer' || userRole === 'super_admin';
